import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import * as React from 'react';
import { ThemeContext } from '../../../context/theme.context';
import Blasts from '../Blasts/Blasts';
import Drilling from '../Drilling/Drilling';
import MaintenenceOperations from '../MaintenenceOperation/MaintenenceOperation';
import Misfires from '../Misfires/Misfires';
import PreLoad from '../PreLoad/PreLoad';
import EquipmentSummary from '../EquipmentSummary/EquipmentSummary';
import ProductionMovements from '../Movements/ProductionMovements';
import WorkbenchTemplate from '../../Settings/Workbench/WorkbenchTemplates';
interface IProps {
  workbench_data: any;
}
interface IState {
  currentTab: any;
}
class TabWorkbench extends React.Component<IProps, IState> {
  private headerText: any;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private current_tab: number = 0;
  private objTab: TabComponent;
  constructor(props: IProps) {
    super(props);
    this.state = {
      currentTab: 0,
    };
    this.headerText = [
      { text: 'Equipment Summary' },
      { text: 'Production Movements' },
      { text: 'Drilling' },
      { text: 'Misfires' },
      { text: 'Pre-Load' },
      { text: 'Blasts' },
      { text: 'Maintenance Operations' },
      { text: 'Workbench Templates' },
    ];
    this.objTab = new TabComponent(props);
  }
  content0 = () => {
    return (
      <div>
        <div className='row mt-3 p-2'>
          <div className='col-md-12'>
            <EquipmentSummary workbench_data={this.props.workbench_data} />
          </div>
        </div>
      </div>
    );
  };
  content1 = () => {
    return (
      <div>
        <div className='row mt-3 p-2'>
          <div className='col-md-12'>
            <ProductionMovements workbench_data={this.props.workbench_data} />
          </div>
        </div>
      </div>
    );
  };
  content2 = () => {
    return (
      <div>
        <div className='row mt-3 p-2'>
          <div className='col-md-12'>
            <Drilling workbench_data={this.props.workbench_data}/>
          </div>
        </div>
      </div>
    );
  };
  content3 = () => {
    return (
      <div>
        <div className='row mt-3 p-2'>
          <div className='col-md-12'>
            <Misfires workbench_data={this.props.workbench_data}/>
          </div>
        </div>
      </div>
    );
  };
  content4 = () => {
    return (
      <div>
        <div className='row mt-3 p-2'>
          <div className='col-md-12'>
            <PreLoad workbench_data={this.props.workbench_data}/>
          </div>
        </div>
      </div>
    );
  };
  content5 = () => {
    return (
      <div>
        <div className='row mt-3 p-2'>
          <div className='col-md-12'>
            <Blasts workbench_data={this.props.workbench_data}/>
          </div>
        </div>
      </div>
    );
  };
  content6 = () => {
    return (
      <div>
        <div className='row mt-3 p-2'>
          <div className='col-md-12'>
            <MaintenenceOperations workbench_data={this.props.workbench_data}/>
          </div>
        </div>
      </div>
    );
  };
  content7 = () => {
    return (
      <div>
        <div className='row mt-3 p-2'>
          <div className='col-md-12'>
            <WorkbenchTemplate
              apply_defaul_button={''}
              apply_template={''}
              isWorkbench={true}
            />
          </div>
        </div>
      </div>
    );
  };
  componentWillUnmount() {
    this.objTab.destroy();
  }
  componentDidUpdate() {
    if (this.context.isChangeCurrentTabWorkbenchBottom) {
      this.current_tab = 7;
      this.context.setChangeCurrentTabWorkbenchBottom(
        false,
        this.context.currentTabWorkbenchBottomIndex
      );
    }
    if (this.context.isChangeTabForTemplateWB) {
      this.current_tab = this.context.ForTemplateWBValue;
      this.context.setChangeTabForTemplateWB(
        false,
        this.context.ForTemplateWBValue
      );
    }
  }
  select(e: any) {
    if (e.isSwiped) {
      e.cancel = true;
    }
  }
  render() {
    return (
      <TabComponent
        selecting={this.select.bind(this)}
        heightAdjustMode='Auto'
        selectedItem={this.current_tab}
        ref={(el: TabComponent) => {
          this.objTab = el;
        }}
        selected={(args: any) => {
          this.current_tab = args.selectingIndex;
        }}
        statelessTemplates={['directiveTemplates']}
      >
        <TabItemsDirective>
          <TabItemDirective
            header={this.headerText[0]}
            content={this.content0}
          />
          <TabItemDirective
            header={this.headerText[1]}
            content={this.content1}
          />
          <TabItemDirective
            header={this.headerText[2]}
            content={this.content2}
          />
          <TabItemDirective
            header={this.headerText[3]}
            content={this.content3}
          />
          <TabItemDirective
            header={this.headerText[4]}
            content={this.content4}
          />
          <TabItemDirective
            header={this.headerText[5]}
            content={this.content5}
          />
          <TabItemDirective
            header={this.headerText[6]}
            content={this.content6}
          />
          <TabItemDirective
            header={this.headerText[7]}
            content={this.content7}
          />
        </TabItemsDirective>
      </TabComponent>
    );
  }
}
export default TabWorkbench;
